export const TipoUsuario = {
  ADMIN: 0,
  COMUM: 1,
  SUPORTE: 2,
};
